import { observer } from "mobx-react";
import React, { FC, useCallback, useMemo } from "react";
import { HStack } from "@chakra-ui/react";
import { AccountAnalyticsStore } from "store/UserAccounts/UserAccount/AccountAnalytics/AccountAnalytics.store";
import {
  LeadAttributionGroupedEnum,
  LeadAttributionStatusEnum,
} from "enums/account-lead-attribution.enum";
import { LeadAttributionPeopleFilterTypes } from "store/UserAccounts/UserAccount/AccountAnalytics/AccountAnalyticsLeadAttributionStore/AccountAnalyticsLeadAttributionPeople.store";
import { LeadAttributionPeopleGroupSubFilterItem } from "./LeadAttributionGroupSubFilterItem";
import { getStatusesForGroup } from "utils/account-lead-attribution-analytics.utils";

const MIN_SELECTION_SIZE = 1;

interface IProps {
  accountAnalyticsStore: AccountAnalyticsStore;
  group: LeadAttributionGroupedEnum | null;
}

export const LeadAttributionPeopleGroupSubFilters: FC<IProps> = observer(
  ({ accountAnalyticsStore, group }) => {
    if (!group) return null;
    const {
      accountAnalyticsLeadAttributionStore: {
        accountLeadAttributionPeopleStore,
      },
    } = accountAnalyticsStore;

    const activeEventTypeFilters = accountLeadAttributionPeopleStore.filters[
      LeadAttributionPeopleFilterTypes.EVENT_TYPE
    ].slice();

    const onFilterChange = useCallback(
      async (value: string) => {
        const status = value as LeadAttributionStatusEnum;
        await accountLeadAttributionPeopleStore.toggleEventTypeFilter(status);
      },
      [accountLeadAttributionPeopleStore]
    );

    const statusOptionsForGroup = useMemo(() => {
      return getStatusesForGroup(group);
    }, [group]);

    const isItemChecked = useCallback(
      status => {
        return activeEventTypeFilters.includes(status);
      },
      [activeEventTypeFilters]
    );

    const isItemDisabled = useCallback(
      status => {
        return (
          isItemChecked(status) &&
          activeEventTypeFilters.length === MIN_SELECTION_SIZE
        );
      },
      [isItemChecked, activeEventTypeFilters.length]
    );

    return (
      <HStack width="100%" alignItems="stretch" spacing={4}>
        {statusOptionsForGroup.map(status => (
          <LeadAttributionPeopleGroupSubFilterItem
            isChecked={isItemChecked}
            onChange={onFilterChange}
            isDisabled={isItemDisabled}
            status={status}
          />
        ))}
      </HStack>
    );
  }
);
